/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

export const MinusIcon: FC<Props> = (props) => (
  <svg viewBox="0 0 16 2" fill="none" {...props}>
    <path
      d="M14.5 1H1"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.92"
      strokeWidth="2"
    />
  </svg>
);
